import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "top", "bottom", "tag"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'img'
};
var CardImg = function CardImg(props) {
  var className = props.className,
    cssModule = props.cssModule,
    top = props.top,
    bottom = props.bottom,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }
  var classes = mapToCssModules(classNames(className, cardImgClassName), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};
CardImg.defaultProps = defaultProps;
export default CardImg;